import { TileType } from '@varo/graphql-schema-types';
import bannerPromotionTiles from 'features/home/HomeScreen/adapters/bannerPromotionTiles/bannerPromotionTiles';
import cardTrackerTile from 'features/home/HomeScreen/adapters/cardTrackerTile/cardTrackerTile';
import columnTaxTile from 'features/home/HomeScreen/adapters/columnTaxTile/columnTaxTile';
import creditScoreTile from 'features/home/HomeScreen/adapters/creditScoreTile/creditScoreTile';
import internalAccountTile from 'features/home/HomeScreen/adapters/internalAccountTile/internalAccountTile';
import linkedAccountsTile from 'features/home/HomeScreen/adapters/linkedAccountsTile/linkedAccountsTile';
import listTile from 'features/home/HomeScreen/adapters/listTile/listTile';
import marketingCarouselTile from 'features/home/HomeScreen/adapters/mapMarketingCarousel/mapMarketingCarousel';
import marketingContentCardTile from 'features/home/HomeScreen/adapters/marketingContentCardTile/marketingContentCardTile';
import nextBestActionTile from 'features/home/HomeScreen/adapters/nextBestActionTile/nextBestActionTile';
import onboardingProgressChecklistTile from 'features/home/HomeScreen/adapters/onboardingProgressChecklistTile/onboardingChecklistTile';
import partnerOfferTile from 'features/home/HomeScreen/adapters/partnerOfferTile/partnerOfferTile';
import payOverTimeTile from 'features/home/HomeScreen/adapters/payOverTimeTile/payOverTimeTile';
import productOfferSingleCardTile from 'features/home/HomeScreen/adapters/ProductOfferSingleCardTile/productOfferSingleCardTile';
import productOfferTile from 'features/home/HomeScreen/adapters/productOfferTile/productOfferTile';
import promotionTiles from 'features/home/HomeScreen/adapters/promotionTiles/promotionTiles';
import selfFundedOfferTile from 'features/home/HomeScreen/adapters/selfFundedOfferTile/selfFundedOfferTile';
import topPerksTile from 'features/home/HomeScreen/adapters/topPerksTile/topPerksTile';
import { varoToAnyoneTile } from 'features/home/HomeScreen/adapters/varoToAnyone/varoToAnyoneTile';
import vxlSideBySideTile from 'features/home/HomeScreen/adapters/vxlSideBySideTile/vxlSideBySideTile';

import { TileAdapterMap } from './types';

const cardAdapterMap: TileAdapterMap = {
  [TileType.CreditScoreTile]: creditScoreTile,
  [TileType.InternalAccount]: internalAccountTile,
  [TileType.List]: listTile,
  [TileType.LinkedAccounts]: linkedAccountsTile,
  [TileType.Promotion]: promotionTiles,
  [TileType.NextBestActionTile]: nextBestActionTile,
  [TileType.VaroToAnyone]: varoToAnyoneTile,
  [TileType.ProductOffer]: productOfferTile,
  [TileType.PartnerOffer]: partnerOfferTile,
  [TileType.MarketingContentCard]: marketingContentCardTile,
  [TileType.MarketingCarousel]: marketingCarouselTile,
  [TileType.VxlSideBySideTile]: vxlSideBySideTile,
  [TileType.TopPerks]: topPerksTile,
  [TileType.BannerPromotion]: bannerPromotionTiles,
  [TileType.VxlTrackerCardTile]: cardTrackerTile,
  [TileType.ColumnTaxTile]: columnTaxTile,
  [TileType.ProductOfferSingleCardTile]: productOfferSingleCardTile,
  [TileType.SelfFundedOfferTile]: selfFundedOfferTile,
  [TileType.VxlCardGroupChecklistTile]: onboardingProgressChecklistTile,
  [TileType.PayOverTimeItemsTile]: payOverTimeTile,
};

export default cardAdapterMap;
